import { createSlice, Draft } from '@reduxjs/toolkit'
import { ICabinetsInfoResponseDto } from '@dto/cabinets/cabinetsInfo/cabinetsInfo.response.dto'

export interface ICabinetsInfo {
  cabinetsList: ICabinetsInfoResponseDto;
  pagination: {
    current: number;
    pageSize: number;
  }
}

const initialState: ICabinetsInfo = {
  cabinetsList: {
    cabinets: [],
    meta: {
      total: 0,
      active: 0,
      inactive: 0,
    }
  },
  pagination: {
    current: 1,
    pageSize: 10
  }
}

export const cabinetsInfoSlice = createSlice({
  name: 'cabinetsInfo',
  initialState,
  reducers: {
    setCabinetsInfoSlice: (state: Draft<ICabinetsInfo>, { payload }) => {
      state.cabinetsList = payload
    },
    setCabinetsPagination: (state: Draft<ICabinetsInfo>, { payload }: { payload: ICabinetsInfo['pagination'] }) => {
      state.pagination = payload
    },
  }
})

export const { setCabinetsInfoSlice, setCabinetsPagination } = cabinetsInfoSlice.actions

export default cabinetsInfoSlice.reducer
